var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcongov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 22.5,
    fill: "#EAECFF",
    stroke: "#F5F6FF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.5C14.5 17.4391 14.9214 16.4217 15.6716 15.6716C16.4217 14.9214 17.4391 14.5 18.5 14.5H30.5C31.5609 14.5 32.5783 14.9214 33.3284 15.6716C34.0786 16.4217 34.5 17.4391 34.5 18.5V30.5C34.5 31.5609 34.0786 32.5783 33.3284 33.3284C32.5783 34.0786 31.5609 34.5 30.5 34.5H18.5C17.4391 34.5 16.4217 34.0786 15.6716 33.3284C14.9214 32.5783 14.5 31.5609 14.5 30.5V18.5Z",
    stroke: "#318FDA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23.5C22.3807 23.5 23.5 22.3807 23.5 21C23.5 19.6193 22.3807 18.5 21 18.5C19.6193 18.5 18.5 19.6193 18.5 21C18.5 22.3807 19.6193 23.5 21 23.5Z",
    stroke: "#318FDA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.026 25.1213L18.5 34.5003H30.633C31.6586 34.5003 32.6422 34.0929 33.3674 33.3677C34.0926 32.6425 34.5 31.6589 34.5 30.6333V30.5003C34.5 30.0343 34.325 29.8553 34.01 29.5103L29.98 25.1153C29.7922 24.9104 29.5637 24.7469 29.3092 24.6353C29.0546 24.5236 28.7796 24.4662 28.5017 24.4668C28.2237 24.4674 27.949 24.5259 27.6949 24.6385C27.4408 24.7512 27.213 24.9157 27.026 25.1213V25.1213Z",
    stroke: "#318FDA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcongov);
export default __webpack_public_path__ + "static/media/image_icon.gov.957ee6de5a58e505d0e5669fa7969676.svg";
export { ForwardRef as ReactComponent };